export default __webpack_public_path__ + "static/media/aiintegrationservices.2de66bdf.png";